import { lazy, Suspense } from 'react';
import Layout from "./pages/Layout.jsx";
import { BrowserRouter as Router, Route, Routes } from 'react-router';

// Lazy load all page components for better performance
const Home = lazy(() => import('./pages/Home'));
const Services = lazy(() => import('./pages/Services'));
const Countries = lazy(() => import('./pages/Countries'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const Blog = lazy(() => import('./pages/Blog'));
const Clients = lazy(() => import('./pages/Clients'));
const BlogPostDetail = lazy(() => import('./pages/BlogPostDetail'));
const FAQ = lazy(() => import('./pages/FAQ'));
const Gallery = lazy(() => import('./pages/Gallery'));
const ServiceDetail = lazy(() => import('./pages/ServiceDetail'));
const CountryDetail = lazy(() => import('./pages/CountryDetail'));
const AccessibilityStatement = lazy(() => import('./pages/AccessibilityStatement'));
const TermsOfUse = lazy(() => import('./pages/TermsOfUse'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));

// Loading fallback component
function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[#E6B800] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-600">טוען...</p>
      </div>
    </div>
  );
}

// 404 Not Found component
function NotFound() {
  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h1>404 - Page Not Found</h1>
      <p>The page you're looking for doesn't exist.</p>
      <a href="/">Go Home</a>
    </div>
  );
}

// Create a wrapper component that uses useLocation inside the Router context
function PagesContent() {
  return (
    <Layout>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/countries" element={<Countries />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/:slug" element={<BlogPostDetail />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/countries/:slug" element={<CountryDetail />} />
          <Route path="/accessibility-statement" element={<AccessibilityStatement />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Layout>
  );
}

export default function Pages() {
  return (
    <Router>
      <PagesContent />
    </Router>
  );
}